(() => {
  if (window.axMenuPromoObserved) return;
  window.axMenuPromoObserved = true;

  // La largeur des cartes est calculee sur 100vw (barre de defilement incluse) :
  // il reste toujours une quinzaine de pixels de debordement. Une carte masquee
  // fait au minimum 290px, le seuil peut donc etre large sans rien manquer.
  const OVERFLOW_THRESHOLD = 40;

  const update = (carousel) => {
    const overflow = carousel.scrollWidth - carousel.clientWidth;
    carousel.classList.toggle('menu-promo__carousel--scrollable', overflow > OVERFLOW_THRESHOLD);
  };

  const observer = new ResizeObserver((entries) => entries.forEach((entry) => update(entry.target)));

  const observe = (root = document) => {
    root.querySelectorAll?.('.menu-promo__carousel').forEach((carousel) => {
      update(carousel);
      observer.observe(carousel);
    });
  };

  observe();
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();
